// extracted by mini-css-extract-plugin
export default {"sourceRow":"BrandModal_sourceRow__-vZs5","sourceItem":"BrandModal_sourceItem__KGDbr","parentBrandDiv":"BrandModal_parentBrandDiv__LjuTf"};